import { render, staticRenderFns } from "./files-to-review-screen.vue?vue&type=template&id=31b0cb25&scoped=true&"
import script from "./files-to-review-screen.vue?vue&type=script&lang=js&"
export * from "./files-to-review-screen.vue?vue&type=script&lang=js&"
import style0 from "./files-to-review-screen.vue?vue&type=style&index=0&id=31b0cb25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b0cb25",
  null
  
)

export default component.exports